import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Box, makeStyles, Theme } from '@material-ui/core'
import clsx from 'clsx'
import React, { forwardRef } from 'react'

import Action, { Props as ActionProps } from './Action'

const useStyles = makeStyles((theme: Theme) => ({
    dragIndicatorContainer: {
        position: 'relative',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    dragIndicator: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: pxToRem(16),
        marginLeft: theme.spacing(0.5),
        '&.big': {
            height: pxToRem(26),
        },
        '&.panleft': {
            position: 'absolute',
            bottom: 'auto',
            right: pxToRem(6.25),
            top: 'calc(50% - 13px)',
        },
    },
    dragBits: {
        height: pxToRem(3.83),
        width: pxToRem(3.83),
        backgroundColor: '#DADADA',
        '&.big': {
            height: pxToRem(6.5),
            width: pxToRem(6.5),
        },
    },
    dragBitRow: {
        width: pxToRem(9.58),
        display: 'flex',
        justifyContent: 'space-between',
        '&.big': {
            width: pxToRem(16.25),
        },
    },
}))

export const Handle = forwardRef<HTMLButtonElement, ActionProps>(
    (props, ref) => {
        const classes = useStyles()
        const size = props?.size ?? ''
        return (
            <Action ref={ref} cursor="grab" {...props}>
                <Box className={classes.dragIndicatorContainer}>
                    <Box
                        className={clsx(classes.dragIndicator, {
                            big: size === 'big',
                            panleft: props.panleft === 'true',
                        })}
                    >
                        <Box
                            className={clsx(classes.dragBitRow, {
                                big: size === 'big',
                            })}
                        >
                            <Box
                                className={clsx(classes.dragBits, {
                                    big: size === 'big',
                                })}
                            ></Box>
                            <Box
                                className={clsx(classes.dragBits, {
                                    big: size === 'big',
                                })}
                            ></Box>
                        </Box>
                        <Box
                            className={clsx(classes.dragBitRow, {
                                big: size === 'big',
                            })}
                        >
                            <Box
                                className={clsx(classes.dragBits, {
                                    big: size === 'big',
                                })}
                            ></Box>
                            <Box
                                className={clsx(classes.dragBits, {
                                    big: size === 'big',
                                })}
                            ></Box>
                        </Box>
                        <Box
                            className={clsx(classes.dragBitRow, {
                                big: size === 'big',
                            })}
                        >
                            <Box
                                className={clsx(classes.dragBits, {
                                    big: size === 'big',
                                })}
                            ></Box>
                            <Box
                                className={clsx(classes.dragBits, {
                                    big: size === 'big',
                                })}
                            ></Box>
                        </Box>
                    </Box>
                </Box>
            </Action>
        )
    }
)
